module.exports = __webpack_public_path__ + "static/media/FacebookOnboard2.f1f51dde.png";